import { EnergyType } from '../EnergyFlow'
import { InefficientProvider } from './common/InefficientProvider'

export class HeatBoilerProvider extends InefficientProvider {
  public readonly providedEnergyTypes = [EnergyType.Heating]

  protected mapDemandToRequirementEnergyType(): EnergyType {
    // Actually this provider uses fuel, but we do not have a separate energy type for that
    return EnergyType.Heating
  }

  protected mapDemandToWasteEnergyType(): EnergyType {
    return EnergyType.Heating
  }
}
